require('../../../assets/scripts/videos/recruiter/jv.Videos.App.webpack.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.dummy.js');